import React, { useState, useRef, useEffect } from 'react';
import { cfLogo } from '../../assets'
import { BsCaretDownFill, BsCloudLightningFill } from 'react-icons/bs';
import { RiSettings4Line, RiLogoutCircleLine } from "react-icons/ri"
import { NavLink } from 'react-router-dom';
import { deleteCookie } from '../../helper';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase'
import {
  BellAlertIcon,
  TrashIcon,
  EyeIcon,
} from "@heroicons/react/24/outline";
import SeeAllNotification from './SeeAllNotification';
import { SelectNotification, clear_all_notification } from '../../layout/Chatbot/chatabotSlice'
import { useDispatch, useSelector } from 'react-redux';
import { selectLogInUsername, setLogInUser,SelectUserEmail } from '../authenticateDashboard/authSlice';
import { resetUniqueBnDevData,resetAuthSlice,resetChatBot,resetCouponWiseData,resetEmailSlice,resetFirstlastSlice,resetpersonaSlice,resetTrafficSlice,resetTrafficSource,resetUtmCampaign,resetutmContent,resetutmMedium,resetutmOverall,resetUtmSource,resetutmTerm,resetuniqueBooking,resetuniqueBoughtSlice,resetsessionDist,resetfacebookData } from './resetReducers';

const Header = () => {
  // const user = useSelector(selectLogInUsername);
  const email = useSelector(SelectUserEmail);

  return (
    <nav className='header backdrop-blur-md bg-black shadow-lg sticky top-0 z-20'>
      <div className="header__container flex justify-between items-center flex-wrap px-4 sm:px-6 lg:px-8 py-3">
        <div className="container__logo sm:!mx-0 mx-auto transform hover:scale-105 transition-transform duration-300">
          <img
            className="mx-auto w-48 sm:w-64 md:w-72 drop-shadow-2xl"
            src={cfLogo}
            alt="logo" />
        </div>
        <div className="container__menu sm:!mx-0 mx-auto">
          <RightMenu>
            <DropDownMenu icon={<BsCaretDownFill />} label={email ?? 'loading...'} />
          </RightMenu>
        </div>
      </div>
    </nav>
  )
}

function RightMenu({ children }) {
  return (
    <div className="rightmenu__container">{children}</div>
  )
}

function DropDownMenu({ icon, label }) {

  const dispatch = useDispatch()
  const [open, setOpen] = React.useState(false);
  const [openNotification, setOpenNotification] = useState(false)
  const adminNotifications = useSelector(SelectNotification)
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  function handleToggleDropDown() {
    setOpen(!open);
  }

  function handleLogout(){
    deleteCookie('user');
    signOut(auth);
    dispatch(resetAuthSlice());
    dispatch(resetChatBot());
    dispatch(resetCouponWiseData());
    dispatch(resetEmailSlice());
    dispatch(resetFirstlastSlice());
    dispatch(resetpersonaSlice());
    dispatch(resetTrafficSlice());
    dispatch(resetTrafficSource());
    dispatch(resetUtmCampaign());
    dispatch(resetutmContent());
    dispatch(resetutmMedium());
    dispatch(resetutmOverall());
    dispatch(resetUtmSource());
    dispatch(resetutmTerm());
    dispatch(resetuniqueBooking());
    dispatch(resetuniqueBoughtSlice());
    dispatch(resetsessionDist());
    dispatch(resetUniqueBnDevData());
    dispatch(resetfacebookData());
    dispatch(setLogInUser(null));
  }

  function handleNotification(action = "") {
    if (action === 'see_all') {
      setOpenNotification(prev => !prev)
    } else if (action === 'clear_all') {
      dispatch(clear_all_notification())
    }
  }


  return (
    <div className="dropdown__container relative" ref={dropdownRef}>
      <div className="dropdown__label flex items-center gap-3 cursor-pointer select-none px-4 py-2.5 rounded-xl bg-white/5 hover:bg-white/10 transition-all duration-300 group" onClick={handleToggleDropDown}>
        <div className='flex gap-2 items-center'>
          <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-500 to-cyan-500 flex items-center justify-center text-white font-bold text-sm shadow-lg">
            {label?.charAt(0)?.toUpperCase() || 'U'}
          </div>
          <span className="dropdown__label--text text-gray-200 font-medium text-sm group-hover:text-white transition-colors truncate max-w-[150px]">{label}</span>
         {/* {adminNotifications?.length ? (<span className='text-white bg-red-500 rounded-full p-1 px-2'>{adminNotifications.length}</span>):null}  */}
        </div>
        <span className={`dropdown__label--icon transition-all duration-500 text-gray-400 group-hover:text-blue-400 ${open && '-rotate-180'}`}>{icon}</span>
      </div>
      <div className={`dropdown__menu absolute right-0 mt-2 rounded-xl shadow-2xl overflow-hidden transition-all duration-300 ${open ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-2 pointer-events-none'}`}>
        {/* <SeeAllNotification open={openNotification} setOpen={setOpenNotification} NotificationObj={adminNotifications} /> */}
        <ul className="dropdown__menu--list py-2 bg-black backdrop-blur-xl text-neutral-200 min-w-[220px]">
          <li className="px-4 py-2">
            <p className="text-xs text-gray-400 font-semibold uppercase tracking-wider">Account</p>
          </li>
          <MenuItem icon={<RiSettings4Line />} label='Settings' link="/settings" />

          {/* <button  className="block dropdown__menu--item cursor-pointer py-1 px-8 hover:bg-[#213c6c] hover:dark:bg-[#213c6c]" >
            <div className="flex items-center gap-2 ">
              <span className="dropdown__menu--item-icon scale-150">< BellAlertIcon className='text-white w-5 h-4'/></span>
              <span className="dropdown__menu--item-label"> Notification({adminNotifications.length})</span>
            </div>
            <div className='flex flex-col gap-1 pl-5'>
            <div className="flex items-center gap-2 cursor-pointer hover:font-bold" onClick={() => handleNotification('see_all')}>
              <span className="dropdown__menu--item-icon scale-150">< EyeIcon className='text-white w-4 h-3'/></span>
              <span className="dropdown__menu--item-label">See All</span>
              </div>
            <div className="flex items-center gap-2 cursor-pointer hover:font-bold " onClick={()=>handleNotification('clear_all')}>
              <span className="dropdown__menu--item-icon scale-150">< TrashIcon className='text-white w-4 h-3'/></span>
              <span className="dropdown__menu--item-label">Clear All</span>
              </div>
            
              </div>
          </button> */}
          <li className="px-2 pt-2">
            <button onClick={handleLogout} className="w-full dropdown__menu--item cursor-pointer py-2.5 px-4 hover:bg-red-500/10 hover:text-red-400 rounded-lg transition-all duration-200 group" >
              <div className="flex items-center gap-3">
                <span className="dropdown__menu--item-icon text-lg group-hover:scale-110 transition-transform"><RiLogoutCircleLine /></span>
                <span className="dropdown__menu--item-label font-medium text-sm">Logout</span>
              </div>
            </button>
          </li>
        </ul>
      </div>
    </div>
  )
}

function MenuItem({ icon, label, link }) {
  return (
    <li className="px-2">
      <NavLink className="dropdown__menu--item cursor-pointer flex py-2.5 px-4 hover:bg-white/10 hover:text-white rounded-lg transition-all duration-200 group" to={link}>
        <div className="flex items-center gap-3">
          <span className="dropdown__menu--item-icon text-lg text-gray-400 group-hover:text-blue-400 group-hover:scale-110 transition-all">{icon}</span>
          <span className="dropdown__menu--item-label font-medium text-sm">{label}</span>
        </div>
      </NavLink>
    </li>
  )
}

export default Header